import { createSelector } from 'reselect';

export const selectSession = (state) => state.session;

export const selectSessionToken = createSelector(selectSession, (session) => session.token);

export const selectSource = createSelector(selectSession, (session) => session.source);

export const selectProfileSaved = createSelector(selectSession, (session) => session.profileSaved);
